import React, { useCallback } from 'react';
import getConfig from 'next/config';
import { useTranslate } from 'nucleus-text';
import { TextLink } from '@cvent/carina/components/TextLink';

import { useFormStyle } from '@hooks/style/useFormStyle';
import { isCoreProduct } from '@components/helpers/FormHelpers';
import { useForgotPassword } from '@components/providers/FormDisplayProvider';
import { useSourceProduct } from '@components/providers/ProductProvider';
import { useAlert } from '@components/providers/ErrorProvider';

const { publicRuntimeConfig } = getConfig();

export const ForgotPasswordTextLink = ({ testID }): JSX.Element => {
  const { updateForgotPassword } = useForgotPassword();
  const { sourceProduct } = useSourceProduct();
  const { translate } = useTranslate();
  const { textLink } = useFormStyle();
  const { updateAlert } = useAlert();

  const onClick = useCallback(() => {
    if (isCoreProduct(sourceProduct.id)) {
      window.location.replace(publicRuntimeConfig.CORE_PASSWORD_RESET_URI);
    } else if (sourceProduct.passwordResetUri) {
      window.location.replace(sourceProduct.passwordResetUri);
    } else {
      updateForgotPassword(true);
      updateAlert({});
    }
  }, [sourceProduct.id, sourceProduct.passwordResetUri, updateAlert, updateForgotPassword]);

  return (
    <TextLink testID={`${testID}_forgotPassword_textLink`} onClick={onClick} css={textLink}>
      {translate('redirect_forgot_login_message')}
    </TextLink>
  );
};
